<script setup lang="ts">
import { usePlayerFlagsStore } from '@/stores/playerFlagsStore.ts'
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import Alert from '@/components/Elements/Alerts/Alert.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { useRoute, useRouter } from 'vue-router'
import { computed, onMounted, onUnmounted, ref, watch } from 'vue'
import { handleNext } from '../tutorialSteps'

const playerFlagsStore = usePlayerFlagsStore()
const route = useRoute()
const router = useRouter()


const isOnMap = computed(() => {
  return route.path.startsWith('/map')
})

const handleNextStep = async () => {
  await handleNext('tutorial_zoom_map')
}

const goToMap = () => {
  router.push('/map')
}

</script>

<template>
  <TutorialFrame
    video-url="https://cdn.ferion.com/videos/advisors/temperate/exploration.webm"
  >
    <template #text>
      <p class="pb-2">
        Excellent!
      </p>
      <p class="pb-2">
        Now let's learn how to zoom in and out to get a better view of the galaxy. You can zoom to see different levels of detail.
      </p>
    </template>

    <template #alerts>
      <Alert type="info" class="hidden md:flex">
        Try zooming in and out by clicking on the zoom buttons : Planet, Solar, Local, Sector, Quadrant or Max.
      </Alert>
      <Alert type="info" class="sm:hidden">
        Try zooming in and out by clicking on the zoom buttons : Planet, Solar, Local, Sector or Quad.
      </Alert>
    </template>

    <template #buttons>
      <ActionButton v-if="!isOnMap" @click="goToMap" class="mr-2">
        Open Map
      </ActionButton>
      <ActionButton @click="handleNextStep">
        Ok, Got it!
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss">

</style>